<template>
	<div>
		<v-layout wrap>
			<v-flex :class="(dialogAdd || dialogEdit) ? 'xs6 sm6 pa-1' : 'xs12 sm12 pa-1'">
				<v-card>
					<v-tabs v-model="tab" icons-and-text>
						<v-tab @click="listPresentation()">
							Schedule Track List
							<v-icon>mdi-calendar-clock</v-icon>
						</v-tab>
					</v-tabs>

					<v-tabs-items v-model="tab">
						<v-tab-item>
							<v-card flat>
								<v-col>
									<v-menu v-model="isShowStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field autocapitalize v-model="startDate" label="Date" append-icon="mdi-calendar" v-on="on"></v-text-field>
										</template>
										<v-date-picker :min="new Date('2020-08-01').toISOString().substr(0, 10)" v-model="startDate" @input="isShowStartDate = false"></v-date-picker>
									</v-menu>
									<v-select item-text="name" item-value="id" v-model="selectedTrackId" :items="trackList" label="Track" required></v-select>
									<div class="text-right">
										<v-btn class="ma-2" @click.prevent="listPresentationScheduleByTrackIdDate()">View schedule</v-btn>
									</div>
								</v-col>
								<br />
								<v-simple-table>
									<template v-slot:default>
										<thead v-if="presentationScheduleList.length != 0">
											<tr>
												<th class="text-left">Date</th>
												<th class="text-left">Time</th>
												<th class="text-left">Presentation</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, idxItem) in presentationScheduleList" :key="idxItem">
												<td>{{ item.startDate.date.year }}-{{ item.startDate.date.month }}-{{ item.startDate.date.day }}</td>
												<td>{{ item.startTime }} - {{item.endTime}}</td>
												<td>
													<span
														v-for="(itemPresentation, idxItemPresentation) in presentationList"
														:key="idxItemPresentation"
													>{{ item.presentationId == itemPresentation.id ? itemPresentation.title : ''}}</span>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-card>
						</v-tab-item>
					</v-tabs-items>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: ["experienceId"],
	components: {},
	data() {
		return {
			valid: true,
			tab: null,
			entity: {
				dataMap: {}
			},
			presentationList: null,
			presentationScheduleList: null,
			selectedPresentationId: null,
			selectedPresentationScheduleId: null,
			isShowStartDate: false,
			isShowStartTime: false,
			isShowEndTime: false,
			startDate: null,
			startTime: null,
			endTime: null,
			trackList: null,
			baseLocation: axios.defaults.baseURL,
			dialogAdd: false,
			dialogEdit: false,
			dialogDelete: false
		};
	},
	mounted() {
		this.listTrack();
		this.listPresentation();
	},
	methods: {
		listPresentation() {
			axios
				.post("/system/presentation/list", {
					experienceId: this.experienceId
				})
				.then(response => {
					this.presentationList = response.data;
				})
				.catch(() => {});
		},
		listPresentationScheduleByTrackIdDate() {
			axios
				.post("/system/presentationschedule/track/date/list", {
					experienceId: this.experienceId,
					trackId: this.selectedTrackId,
					date: this.startDate + " " + "00:00"
				})
				.then(response => {
					this.presentationScheduleList = response.data;
				})
				.catch(() => {});
		},
		listTrack() {
			axios
				.post("/system/track/list", {
					experienceId: this.experienceId
				})
				.then(response => {
					this.trackList = response.data;
				})
				.catch(() => {});
		}
	}
};
</script>
